var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarningDisclaimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 24,
    height: 24,
    role: "img",
    "aria-label": "Earnings disclaimer icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cutout"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 64,
    width: 768,
    height: 896,
    rx: 96,
    ry: 96,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "42%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Segoe UI, Roboto, Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 450,
    fill: "black"
  }, "\n\xA0\xA0\xA0\xA0$\n\xA0\xA0\xA0"), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 640,
    width: 640,
    height: 40,
    rx: 28,
    ry: 28,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 740,
    width: 640,
    height: 40,
    rx: 28,
    ry: 28,
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 64,
    width: 768,
    height: 896,
    rx: 96,
    ry: 96,
    fill: "black",
    mask: "url(#cutout)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningDisclaimer);
export default __webpack_public_path__ + "static/media/earningDisclaimer.89c8cc2c7f76578a765b37acef30b9c6.svg";
export { ForwardRef as ReactComponent };